import React from 'react';
import { FilterSection, AdvancedFilters } from "@/components/ui";
import { SORT_OPTIONS } from "@/constants/globalConstants";
import { PROJECT_PIPELINE_STAGES } from "../verve-projects-flow/constants/projectConstants";
import { useAuthStore } from "@/store/authStore";

export const ProjectsControlPanel = ({
  search, setSearch,
  filters, setFilters,
  sortBy, setSortBy,
  showAdvancedFilters, setShowAdvancedFilters,
  view, setView,
  onAddClick,
  onExport,
  isExporting,
  filterOptions = { locations: [], sources: [], assignees: [] },
  activityStats,
  onReset
}) => {
  const { user } = useAuthStore();
  const userRole = (user?.role || "").toLowerCase().trim().replace(/[-_\s]+/g, "-");
  //updated by Halimunnisa on 10-06-2026 - Added ProjectsControlPanel component with integrated search, advanced filtering, sorting, view toggling, and export functionality for Verve Projects dashboard, along with dynamic filter options based on project data and user role-based access control for certain filters and actions.
  const stageOptions = PROJECT_PIPELINE_STAGES.map((stage) => ({
    value: stage,
    label: stage,
  }));

  const filterConfig = {
    status: {
      label: 'Status',
      options: stageOptions,
    },
    location: {
      label: 'Location',
      options: filterOptions.locations.map(city => ({ value: city, label: city }))
    },
    source: {
      label: 'Source',
      options: filterOptions.sources.map(source => ({ value: source, label: source }))
    },
    assignedTo: {
      label: 'Assigned PM',
      options: filterOptions.assignees.map(a => ({ value: a.id, label: a.name }))
    }
  };

  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={setFilters}
      onAddClick={onAddClick}
      addLabel="Add Project"
      onExport={onExport}
      isExporting={isExporting}
      isAdvancedFilterInline={true}
      statusFilterKey="projectStatus"
      statusOptions={stageOptions}
      statusPlaceholder="All Project Stages"
      AdvancedFiltersComponent={({ isInline }) => (
        <AdvancedFilters
          filters={filters}
          onFilterChange={(key, value) => setFilters(prev => ({ ...prev, [key]: value }))}
          sortBy={sortBy}
          onSortChange={setSortBy}
          sortOptions={SORT_OPTIONS}
          config={filterConfig}
          isInline={isInline}
        />
      )}
    />
  );
};
